import React, { AnchorHTMLAttributes } from 'react'
import classNames from 'classnames'
import { getLink } from '@helpers/env'
import styles from './styles.module.scss'

type LinkTextSize = 'regular' | 'large' | 'small'

export type LinkProps = {
  href: string
  classes?: string
  text?: string
  textSize?: LinkTextSize
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
  target?: string
  rawHref?: boolean
  underlined?: boolean
  variant?: 'primary' | 'white'
} & AnchorHTMLAttributes<HTMLAnchorElement>

const Link = ({
  variant = 'primary',
  underlined = true,
  textSize = 'regular',
  href,
  classes,
  text,
  onClick,
  children,
  target,
  rawHref,
  ...props
}: React.PropsWithChildren<LinkProps>) => {
  const linkClasses = classNames(
    styles.link,
    styles[`textSize_${textSize}`],
    styles[variant],
    classes,
    {
      [styles.underlined]: underlined
    }
  )
  return (
    <a
      {...props}
      {...(target && { target })}
      {...(onClick && { onClick })}
      href={rawHref ? href : getLink(href)}
      className={linkClasses}
    >
      {children || text}
    </a>
  )
}

export default Link
